import React, { useContext } from 'react'
import { ClientListManagerContext, Order } from '~/service/ClientListManager'
import classNames from 'classnames'
import { FormattedMessage } from '~/translations/utils'

const TableHeader: React.FC = ({}) => {
  const { filter, order, setFilter, setOrder } = useContext(
    ClientListManagerContext
  )

  const sort = (name: Order) => {
    setOrder(name)
    setFilter({
      ...filter,
      order: name,
    })
  }

  return (
    <>
      <div className="list-table-header">
        <a
          className={classNames('client-list-table-header-name', {
            active: order.includes('name'),
          })}
          href="#"
          onClick={e => {
            e.preventDefault()
            order == 'nameDesc' ? sort('nameAsc') : sort('nameDesc')
          }}
        >
          <FormattedMessage id="clients / table / header / name" />
          {order.includes('name') && (
            <span
              className={classNames(
                'fa client-list-table-header-arrow',
                { 'fa-caret-up': order == 'nameAsc' },
                { 'fa-caret-down': order == 'nameDesc' }
              )}
            />
          )}
        </a>
        <a
          className={classNames('client-list-table-header-added', {
            active: order.includes('added'),
          })}
          href="#"
          onClick={e => {
            e.preventDefault()
            order == 'addedDesc' ? sort('addedAsc') : sort('addedDesc')
          }}
        >
          <FormattedMessage id="clients / table / header / added" />
          {order.includes('added') && (
            <span
              className={classNames(
                'fa client-list-table-header-arrow',
                { 'fa-caret-up': order == 'addedAsc' },
                { 'fa-caret-down': order == 'addedDesc' }
              )}
            />
          )}
        </a>
      </div>
    </>
  )
}

export default TableHeader
